import React, { useState, useEffect } from 'react';
import { Url } from "../../url";
import './../../entrydoor.css';

const DoorLiteSize = ({ value, onChange, label = 'Lite Size', selectedPanel = null }) => {
    const [selectedDoorLiteSize, setSelectedDoorLiteSize] = useState(value || "");
    const [liteSizes, setLiteSizes] = useState([]); // State to store fetched lite sizes
    //const [doorLiteSizeValue, setDoorLiteSizeValue] = useState("");

    useEffect(() => {
        const fetchLiteSizes = async () => {
            if (selectedPanel) {;}

            const selectedCollection = 'Decorative Glass';
            if (selectedCollection) {
                try {
                    selectedPanel.value = 'WG00';
                    const response = await fetch(`${Url}/litesize?collection=${selectedCollection}&panel=${selectedPanel.value}`);
                    if (!response.ok) {
                        throw new Error(`Failed to fetch lite sizes: ${response.status}`);
                    }
                    const data = await response.json();
                    setLiteSizes(data); // Update liteSizes with data from API
                    if (data.length > 0 && !selectedDoorLiteSize) {
                        // Select the first item automatically when collection is set and there's no selected value
                        setSelectedDoorLiteSize(data[0].value);
                    }
                } catch (error) {
                    console.error("Error fetching lite sizes:", error);
                    alert("An error occurred while fetching lite sizes.");
                }
            } else {
                setLiteSizes([]);
                setSelectedDoorLiteSize(""); // Reset the selection if no collection is selected
            }
        };

        fetchLiteSizes();
    }, [selectedPanel]); // Dependency on selectedCollection

    const handleDoorLiteSizeChangePrev = (e) => {
        const newValue = e.target.value;
        setSelectedDoorLiteSize(newValue);
    
        // Only proceed if a valid value is selected
        if (newValue) {
            let currentCollection;
            const element = document.getElementById("DoorLiteCollection");
    
            // Get the current collection value if the element exists
            if (element) {
                currentCollection = element.value;
            }
    
            // Find the selected item with additional filtering
            let selectedItem;
            if (currentCollection) {
                selectedItem = liteSizes.find(
                    (size) => size.value === newValue && size.collection === currentCollection
                );
            } else {
                selectedItem = liteSizes.find((size) => size.value === newValue);
            }
    
            // Trigger onChange with the full item data
            if (selectedItem) {
                onChange(selectedItem); // Pass the full selected item instead of just the value
                alert(JSON.stringify(selectedItem, null, 2));
            }
        }
    };

    const handleDoorLiteSizeChange = (e) => {
        const newValue = e.target.value;
        setSelectedDoorLiteSize(newValue); // Update the local state
    
        if (newValue) {
            let currentCollection;
            const element = document.getElementById("DoorLiteCollection");
    
            // Get the current collection value if the element exists
            if (element) {
                currentCollection = element.value;
            }
    
            // Find the selected item with additional filtering
            let selectedItem;
            if (currentCollection && false) { // no need anymore!...apr 01, 2025
                selectedItem = liteSizes.find(
                    (size) => size.value === newValue && size.collection === currentCollection
                );
            } else {
                selectedItem = liteSizes.find((size) => size.value === newValue);
            }
    
            // Ensure the full selected item is passed to the parent
            if (selectedItem) {
                onChange(selectedItem); // Send the entire selectedItem object to the parent
            }
        }
    };
          

    return (
        <div className="a-container">
            <label htmlFor="DoorLiteSize">{label}</label>
            <select
                id="DoorLiteSize"
                value={selectedDoorLiteSize}
                onChange={handleDoorLiteSizeChange}
            >
                {liteSizes.map((size) => (
                    <option key={size.id} value={size.value}>
                        {selectedDoorLiteSize === size.value ? `${size.value} ✔` : size.value}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default DoorLiteSize;
